import React from 'react';
import styled from 'styled-components';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import { useHistory } from 'react-router-dom';

const Link = styled.div`
  color: ${({ theme }) => theme.grey.dark};
  font-size: 14px;
  margin-top: 10px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const MorePaymentMethods = () => {
  const history = useHistory();

  return <Link onClick={replaceUrlParams(history, '#modal-payment-methods-new', false)}>mais formas de pagamento</Link>;
};
